export function monthPicker(that, trs) {
  return [
    {
      h: "div",
      c: "month-picker",
      z: [
        {
          h: "div",
          c: "action-header",
          z: [
            {
              h: "div",
              c: "action-item-left",
              html: "«",
              event: (ev) => {
                that.selectFirst(ev);
              },
            },
            {
              h: "div",
              c: "action-item-content",
              html: `${that.value.year}`,
            },
            {
              h: "div",
              c: "action-item-right",
              html: "»",
              event: (ev) => {
                that.selectLast(ev);
              },
            },
          ],
        },
        {
          h: "div",
          c: "action-mian",
          z: [
            {
              h: "table",
              c: "month-panel",
              z: [
                {
                  h: "tbody",
                  c: "",
                  z: trs,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
}
